import { createContext, useContext } from "react";

// Per-pane portal container for Radix overlays (dialogs, sheets, popovers, context menus).
// Radix portals default to document.body, which ESCAPES the <Activity> freeze boundary — an
// overlay left open at switch/freeze time would keep floating over the lock screen or the
// next user's session, with its dismissal listeners unmounted (Escape/outside-click dead).
// Each workspace pane instead provides its own body-level container div whose `display` the
// host toggles in lockstep with pane visibility, so overlays hide and reappear WITH their
// pane. Null (default) = not inside a pane → primitives fall back to document.body.
export const OverlayContainerContext = createContext(null);

export function useOverlayContainer() {
  return useContext(OverlayContainerContext);
}
